import React from 'react';
import { Divider } from 'semantic-ui-react';
import Content from '../Content';
import PaginationWrapper from '../PaginationWrapper';
import PathView from '../PathView';
import TasksList from '../TasksListComponents/List';
import { TasksFiltersWithAssignee } from '../TasksListComponents/TasksFilters';
import { initialFilters } from './withAllTasksQuery';
import withFilterActions from '../HOC/withFilterActions';
import ManageMenu from './ManageMenu';

const grid = {
  minWidth: '950px',
  selectWidth: 1,
  priorityWidth: 2,
  descriptionWidth: 4,
  assigneeWidth: 3,
  idWidth: 1,
  statusWidth: 3,
  dateWidth: 2,
};

const MenuItems = withFilterActions('manager-tasks')(initialFilters)(TasksFiltersWithAssignee);

const View = ({ checkboxesProps, loading, pageInfo, tasks, totalCount, refetchTasks }) => (
  <Content
    MenuItems={checkboxesProps.checkedCount ? ManageMenu : MenuItems}
    menuProps={{
      number: checkboxesProps.checkedCount,
      selectedTaskIds: checkboxesProps.selectedTaskIds,
      refetchTasks,
    }}
    loading={loading}
  >
    <PathView paths={[{ name: 'Tasks Manager' }]} />
    <Divider hidden />
    <TasksList tasks={tasks} grid={grid} checkboxesProps={checkboxesProps} />
    <Divider hidden />
    <PaginationWrapper {...pageInfo} totalCount={totalCount} />
  </Content>
);

export default View;



// WEBPACK FOOTER //
// ./src/component/TasksManagerList/View.js